export const DOSSIER_LESSONS_AR = [
  {
    id: 'dossier-1',
    numero: 1,
    titre: "تحديد الوثائق المطلوبة",
    sousTitre: "ماذا أحتاج بالضبط؟",
    contexte: "طُلب منك تقديم ملف كامل. كيف تعرف ما هو مطلوب وتجمعه بشكل صحيح؟",
    explication: [
      "**اقرأ القائمة بعناية**: ابدأ بقراءة قائمة الوثائق المطلوبة كاملة قبل البحث عن أي وثيقة.",
      "**الوثائق الشائعة**: إثبات الإقامة (فاتورة أقل من 3 أشهر)، وثيقة هوية، RIB، كشف الراتب، إشعار الضريبة.",
      "**إثبات الإقامة**: فاتورة الكهرباء، الغاز، الهاتف، أو إيصال الإيجار — يجب أن تكون أقل من 3 أشهر.",
      "**RIB**: وثيقة بيانات حسابك البنكي — احصل عليها من تطبيق بنكك أو شباكه.",
      "**تحقق من التواريخ**: بعض الوثائق لها مدة صلاحية (أقل من 3 أشهر، أقل من 6 أشهر). تحقق دائماً قبل الإرسال.",
    ],
    question: "إثبات الإقامة يجب ألا يتجاوز عمره...",
    options: [
      { id: 'a', text: "3 أشهر", correct: true },
      { id: 'b', text: "6 أشهر", correct: false },
      { id: 'c', text: "سنة واحدة", correct: false },
    ],
    explication_reponse: "إثبات الإقامة يجب أن يكون أقل من 3 أشهر. فاتورة EDF أو إيصال إيجار أو فاتورة هاتف ثابت — تحقق من تاريخها قبل إرسالها.",
  },
  {
    id: 'dossier-2',
    numero: 2,
    titre: "فحص أو تصوير وثائقك",
    sousTitre: "نسخة رقمية واضحة",
    contexte: "الوثائق جاهزة ورقياً. الآن تحتاج إلى نسخة رقمية للإرسال الإلكتروني. إليك الطريقة الصحيحة.",
    explication: [
      "**تطبيقات الفحص المجانية**: Adobe Scan، CamScanner، أو Microsoft Lens — تحوّل صورة هاتفك إلى PDF واضح.",
      "**الإضاءة**: ضع الوثيقة على سطح ناعم مضيء. تجنب الظلال والانعكاسات. الضوء الطبيعي ممتاز.",
      "**الوثيقة مسطّحة**: لا تمسك الورقة في الهواء — ضعها مسطّحة تماماً لصورة واضحة.",
      "**الجودة والحجم**: يجب أن تكون كل المعلومات قابلة للقراءة. حجم مقبول: بين 500 كيلوبايت و2 ميغابايت.",
      "**تحقق من النتيجة**: قبل الإرسال، افتح الملف وتحقق أن كل شيء واضح — النصوص والأرقام والتواريخ.",
    ],
    question: "ما أفضل طريقة لتصوير وثيقة بهاتفك للحصول على صورة واضحة؟",
    options: [
      { id: 'a', text: "الوثيقة مسطّحة، إضاءة جيدة، تطبيق فحص", correct: true },
      { id: 'b', text: "الوثيقة في اليد مع فلاش الكاميرا", correct: false },
      { id: 'c', text: "لا يهم الأسلوب طالما الصورة مأخوذة", correct: false },
    ],
    explication_reponse: "الوثيقة المسطّحة مع ضوء طبيعي وتطبيق فحص تعطي أفضل النتائج. التطبيق يصحّح التشوّه ويحسّن التباين تلقائياً.",
  },
  {
    id: 'dossier-3',
    numero: 3,
    titre: "تسمية وتنظيم ملفاتك",
    sousTitre: "لا تضيع وثيقة",
    contexte: "عندك عشرات الملفات باسم 'scan001', 'photo.jpg'... كيف تنظّمها لإيجادها فوراً؟",
    explication: [
      "**اصطلاح التسمية**: اعتمد صيغة ثابتة — 'نوع الوثيقة_الاسم_التاريخ.pdf'. مثلاً: 'RIB_بن_علي_2026.pdf'.",
      "**مجلدات حسب الجهة**: أنشئ مجلداً لكل جهة — مجلد CAF، مجلد Impôts، مجلد Santé.",
      "**النسخ الاحتياطية في السحابة**: Google Drive أو iCloud — وثائقك متاحة من أي جهاز وفي أمان حتى لو ضاع هاتفك.",
      "**لا تحذف الوثائق القديمة**: إشعار ضريبة 2020 قد تحتاجه في 2026. الوثائق الإدارية تحتفظ بها 5 إلى 10 سنوات.",
      "**تجميع الملف**: عند إرسال ملف كامل، يمكنك دمج عدة PDF في واحد على ilovepdf.com — أسهل للإرسال.",
    ],
    question: "ما الاسم الأفضل لملف RIB تريد إرساله؟",
    options: [
      { id: 'a', text: "RIB_NomPrenom_2026.pdf", correct: true },
      { id: 'b', text: "scan001.jpg", correct: false },
      { id: 'c', text: "document.pdf", correct: false },
    ],
    explication_reponse: "اسم واضح يسهّل على الموظف تحديد الوثيقة وتصنيفها. 'scan001' أو 'document' لا يعطي أي معلومة وقد يتسبب في تأخير ملفك.",
  },
  {
    id: 'dossier-4',
    numero: 4,
    titre: "إرسال ملفك ومتابعته",
    sousTitre: "حتى التأكيد",
    contexte: "الملف جاهز. الآن يجب إرساله والتأكد من استلامه — وماذا تفعل إذا لم يُعالَج؟",
    explication: [
      "**الإرسال الإلكتروني**: على الموقع الرسمي للجهة، في قسم 'ملفي' أو 'إرسال وثيقة'. بريد إلكتروني كبديل.",
      "**إيصال الاستلام**: احتفظ دائماً بإيصال الإرسال — التاريخ والساعة مهمان لإثبات أنك أرسلت في الوقت المحدد.",
      "**لقطة الشاشة**: بعد الإرسال على موقع إلكتروني، خذ لقطة شاشة للتأكيد. على الهاتف: زر الصوت + زر الطاقة.",
      "**إذا لم يُعالَج الملف**: انتظر 15 يوماً عمل ثم تابع — بالاتصال برقم الجهة أو عبر المراسلة الإلكترونية.",
      "**احتفظ بنسخة كل شيء**: نسخة من الوثائق التي أرسلتها + إيصال الإرسال + أي مراسلة لاحقة.",
    ],
    question: "أرسلت ملفك إلكترونياً. ما الذي يجب الاحتفاظ به كدليل؟",
    options: [
      { id: 'a', text: "لقطة شاشة أو إيصال التأكيد مع التاريخ", correct: true },
      { id: 'b', text: "لا شيء — الإرسال الإلكتروني لا يحتاج دليلاً", correct: false },
      { id: 'c', text: "فقط اسم الموظف الذي استقبل الملف", correct: false },
    ],
    explication_reponse: "التاريخ والساعة مهمان جداً — إثبات أنك أرسلت قبل الموعد النهائي. احتفظ بلقطة الشاشة في مجلد خاص بالمراسلات الإدارية.",
  },
];
